const br = {
	group: "inline",
	inline: true,
	atom: true,
	selectable: false,
};

export default br;
